import { Component, ElementRef, Input } from '@angular/core'
import { BookingHubComponent } from './components/booking-hub/booking-hub.component'
import { CommonModule } from '@angular/common'
import {
    FmWindowResizedDirective,
    WindowResizedType,
} from '@app/shared/directives/fm-window-resized.directive'
import { SelectedSession, SelectedSessionService } from '@app/core/_services'
import { Subject, takeUntil } from 'rxjs'
import { SelectedSessionsListComponent } from './components/selected-sessions-list/selected-sessions-list.component'
import { ScrollPanelModule } from 'primeng/scrollpanel'
import { UpcomingSessionPanelComponent } from './components/upcoming-session-panel/upcoming-session-panel.component'

@Component({
    selector: 'fm-left-panel',
    imports: [
        UpcomingSessionPanelComponent,
        SelectedSessionsListComponent,
        BookingHubComponent,
        CommonModule,
        ScrollPanelModule,
    ],
    templateUrl: './left-panel.component.html',
    styleUrl: './left-panel.component.scss',
})
export class LeftPanelComponent {
    @Input() hideBookingHubOnMobile = false
    //@Input() panelHeight: number
    private ngUnsubscribe: Subject<any> = new Subject<any>()

    //private mutationObserver: MutationObserver
    public enableScrollbar: boolean = false
    public selectedSessions: SelectedSession[] = []

    constructor(
        private selectedSessionService: SelectedSessionService,
        //private elementRef: ElementRef,
    ) {}

    onDomChange(viewport: WindowResizedType) {
        // this.determineScrollBarStatus()
    }

    ngOnInit(): void {
        this.selectedSessionService.selectedSessions$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((selectedSessions: SelectedSession[]) => {
                this.selectedSessions = [...selectedSessions]
            })
    }

    ngAfterViewInit() {
        // this.determineScrollBarStatus()
        // // Confess: Could not figure out how to get the parent div to have an
        // // auto height and still allow for the p-scrollpanel to detect when it's
        // // overflowed. This workaround will do for now
        // this.mutationObserver = new MutationObserver(() => {
        //     this.determineScrollBarStatus()
        // })
        // this.mutationObserver.observe(this.elementRef.nativeElement, {
        //     childList: true,
        //     subtree: true,
        //     characterData: false,
        //     attributes: false,
        // })
    }

    // private determineScrollBarStatus(): void {
    //     if (this.elementRef && this.elementRef.nativeElement.parentElement) {
    //         if (
    //             this.elementRef.nativeElement.offsetHeight >
    //             this.elementRef.nativeElement.parentElement.offsetHeight
    //         ) {
    //             this.enableScrollbar = true
    //         } else {
    //             this.enableScrollbar = false
    //         }
    //     }
    // }
    ngOnDestroy() {
        // if (this.mutationObserver) {
        //     this.mutationObserver.disconnect()
        // }
        this.ngUnsubscribe.next(null)
        this.ngUnsubscribe.complete()
    }
}
